<nb-card class="cs-dialog">
  <nb-card-header>
    <div class="cs-head">
      <div>
        <h5>{{ 'dialogs.courseStructure.title' | translate }}</h5>
        <p class="muted">{{ course.fullname || course.shortname }}</p>
      </div>
      <div class="cs-head__actions">
        <button
          nbButton
          ghost
          status="basic"
          class="cs-reparse-btn"
          [disabled]="loading || reparsing"
          (click)="reparse()"
          [title]="'dialogs.courseStructure.reanalyse' | translate"
          [attr.aria-label]="'dialogs.courseStructure.reanalyse' | translate"
        >
          <nb-icon icon="refresh-outline" [class.is-spinning]="reparsing"></nb-icon>
        </button>
        <button nbButton ghost status="basic" (click)="ref.close()"><nb-icon icon="close-outline"></nb-icon></button>
      </div>
    </div>
  </nb-card-header>

  <nb-card-body>
    <!-- Lernziel-Register (PRD mastery-objectives M2/M3): customer goals,
         own objectives, links — once the course is known. -->
    <app-segmented-control
      *ngIf="data?.course_id"
      class="cs-views"
      [options]="viewOptions"
      [value]="view"
      [ariaLabel]="'dialogs.courseStructure.viewLabel' | translate"
      (valueChange)="view = $any($event)"
    ></app-segmented-control>
    <app-objective-register
      *ngIf="view === 'register' && data?.course_id"
      [courseId]="data!.course_id"
      [chapters]="registerChapters"
    ></app-objective-register>

    <ng-container *ngIf="view === 'structure'">
    <div class="cs-loading" *ngIf="loading">
      <nb-icon icon="loader-outline"></nb-icon> {{ 'dialogs.courseStructure.loading' | translate }}
    </div>

    <div
      class="cs-reparse-status"
      *ngIf="reparseMessage"
      [class.is-error]="reparseFailed"
    >
      <span class="cs-reparse-status__dot" *ngIf="reparsing" aria-hidden="true"></span>
      {{ reparseMessage }}
    </div>

    <!-- Der Leerzustand gilt nur, wenn auch nichts laeuft. Waehrend einer
         Analyse steht oben die laufende Meldung — sonst behauptet der Dialog,
         es gebe nichts, waehrend im Hintergrund genau das entsteht. -->
    <p class="cs-empty" *ngIf="!loading && !reparsing && (error || !hasStructure)">
      {{ 'dialogs.courseStructure.empty' | translate }}
    </p>

    <ng-container *ngIf="!loading && hasStructure">
      <div class="cs-meta">
        <span class="cs-stat">{{ data?.chapters?.length }} Kapitel</span>
        <span class="cs-stat">{{ totalObjectives }} Lernziele</span>
        <span class="cs-stat">{{ totalExercises }} Übungen</span>
        <span
          class="cs-stat"
          [class.cs-stat--ok]="scriptState === 'complete'"
          [class.cs-stat--busy]="scriptState === 'running' || scriptState === 'stalled'"
          [class.cs-stat--bad]="scriptState === 'failed'"
          [attr.title]="scriptStateKey | translate: scriptStateParams"
        >{{ totalScriptsDone }}/{{ totalUnits }} Skripte<ng-container
          *ngIf="scriptState === 'running'"> · {{ 'dialogs.courseStructure.scripts.badgeRunning' | translate }}</ng-container><ng-container
          *ngIf="scriptState === 'stalled'"> · {{ 'dialogs.courseStructure.scripts.badgeStalled' | translate }}</ng-container><ng-container
          *ngIf="scriptState === 'failed'"> · {{ 'dialogs.courseStructure.scripts.badgeFailed' | translate }}</ng-container></span>
        <span class="cs-stat muted" *ngIf="data?.structure?.language">Sprache: {{ data?.structure?.language }}</span>
        <span class="cs-spacer"></span>
        <button
          nbButton
          ghost
          size="tiny"
          status="basic"
          class="cs-toggle-all"
          (click)="toggleAll()"
          [attr.title]="allExpanded ? 'Alle einklappen' : 'Alle ausklappen'"
          [attr.aria-label]="allExpanded ? 'Alle einklappen' : 'Alle ausklappen'"
        >
          <nb-icon [icon]="allExpanded ? 'collapse-outline' : 'expand-outline'"></nb-icon>
        </button>
      </div>

      <p class="cs-scripthint" *ngIf="scriptState !== 'complete'">
        {{ scriptStateKey | translate: scriptStateParams }}
        {{ 'dialogs.courseStructure.scripts.consequence' | translate }}
      </p>

      <ol class="cs-chapters">
        <li *ngFor="let ch of data?.chapters; let chIdx = index" class="cs-chapter" [class.is-open]="isOpen(ch.id)">
          <button type="button" class="cs-chapter__head" (click)="toggle(ch.id)">
            <span class="cs-toggle" [class.is-open]="isOpen(ch.id)"></span>
            <!-- Positional 1..n — display_order comes from the parser and may
                 start at 1 or skip (dropped intro), which showed "2..7". -->
            <span class="cs-order">{{ chIdx + 1 }}</span>
            <span class="cs-title">{{ ch.title }}</span>
            <span class="cs-badge cs-badge--assess" *ngIf="ch.is_assessment">Prüfung</span>
            <span class="cs-counts">
              <span *ngIf="ch.objectives?.length">🎯 {{ ch.objectives.length }}</span>
              <span *ngIf="ch.exercises?.length">✎ {{ ch.exercises.length }}</span>
            </span>
          </button>

          <div class="cs-chapter__body" *ngIf="isOpen(ch.id)">
            <p class="cs-summary" *ngIf="ch.summary">{{ ch.summary }}</p>

            <div class="cs-section" *ngIf="!ch.sections?.length">
              <h6>Lehreinheit <span class="cs-muted">(ganzes Kapitel)</span></h6>
              <ul class="cs-subsections">
                <li>
                  <span
                    [class]="'cs-script cs-script--' + scriptStatus(ch, 0)"
                    [title]="scriptLabel(scriptStatus(ch, 0))"
                    [attr.aria-label]="scriptLabel(scriptStatus(ch, 0))"
                  ></span>
                  <span>{{ ch.title }}</span>
                  <span class="cs-muted" *ngIf="ch.page_start"> · S. {{ ch.page_start }}–{{ ch.page_end }}</span>
                  <button
                    *ngIf="scriptStatus(ch, 0) === 'done'"
                    type="button" class="cs-script-open"
                    (click)="openScript(ch, 0, ch.title, $event)"
                    title="Unterrichtsskript ansehen" aria-label="Unterrichtsskript ansehen"
                  ><nb-icon icon="eye-outline"></nb-icon></button>
                </li>
              </ul>
            </div>

            <div class="cs-section" *ngIf="ch.sections?.length">
              <h6>Unterkapitel <span class="cs-muted">({{ ch.sections.length }} Lehreinheiten · {{ chapterScriptsDone(ch) }}/{{ ch.sections.length }} Skripte)</span></h6>
              <ul class="cs-subsections">
                <li *ngFor="let s of ch.sections; let i = index">
                  <span
                    class="cs-script"
                    [class]="'cs-script cs-script--' + scriptStatus(ch, i)"
                    [title]="scriptLabel(scriptStatus(ch, i))"
                    [attr.aria-label]="scriptLabel(scriptStatus(ch, i))"
                  ></span>
                  <span class="cs-subnum" *ngIf="s.number">{{ s.number }}</span>
                  <span>{{ s.title }}</span>
                  <span class="cs-muted" *ngIf="s.page_start"> · S. {{ s.page_start }}–{{ s.page_end }}</span>
                  <button
                    *ngIf="scriptStatus(ch, i) === 'done'"
                    type="button" class="cs-script-open"
                    (click)="openScript(ch, i, s.title, $event)"
                    title="Unterrichtsskript ansehen" aria-label="Unterrichtsskript ansehen"
                  ><nb-icon icon="eye-outline"></nb-icon></button>
                </li>
              </ul>
            </div>

            <div class="cs-section" *ngIf="ch.objectives?.length">
              <h6>Lernziele</h6>
              <ul class="cs-objectives">
                <li *ngFor="let o of ch.objectives">
                  <span class="cs-bloom" [class]="'status-' + bloomStatus(o.bloom_level)" *ngIf="o.bloom_level">{{ o.bloom_level }}</span>
                  <span>{{ o.description }}</span>
                </li>
              </ul>
            </div>

            <div class="cs-section" *ngIf="ch.exercises?.length">
              <h6>Übungen</h6>
              <ul class="cs-exercises">
                <li *ngFor="let ex of ch.exercises">
                  <nb-icon icon="edit-2-outline"></nb-icon>
                  <span class="cs-ex-title">{{ ex.title }}</span>
                  <span class="cs-badge cs-badge--src">{{ ex.source }}</span>
                  <span class="muted" *ngIf="ex.difficulty">· {{ ex.difficulty }}</span>
                </li>
              </ul>
            </div>

            <p class="muted cs-cmids" *ngIf="ch.moodle_cmids?.length">
              Moodle-Module: {{ ch.moodle_cmids.join(', ') }}
            </p>
          </div>
        </li>
      </ol>
    </ng-container>

    <!-- Script reader: what the tutor actually teaches from, plus corrections -->
    <div class="cs-script-view" *ngIf="scriptOpenFor">
      <div class="cs-script-view__head">
        <h6>Unterrichtsskript · {{ scriptOpenFor.title }}</h6>
        <button nbButton ghost size="tiny" status="basic" (click)="closeScript()">
          <nb-icon icon="close-outline"></nb-icon>
        </button>
      </div>

      <div class="cs-loading" *ngIf="scriptLoading">Lade Skript…</div>
      <p class="cs-empty" *ngIf="scriptError">Skript konnte nicht geladen werden.</p>

      <ng-container *ngIf="!scriptLoading && scriptData?.script as sc">
        <div class="cs-script-sec" *ngIf="sc.key_points?.length">
          <h6>Kernaussagen</h6>
          <ul><li *ngFor="let k of sc.key_points">{{ k }}</li></ul>
        </div>
        <div class="cs-script-sec" *ngIf="sc.explanation_md">
          <h6>Erklärung</h6>
          <p class="cs-script-text">{{ sc.explanation_md }}</p>
        </div>
        <div class="cs-script-sec" *ngIf="sc.worked_example">
          <h6>Beispiel</h6>
          <p class="cs-script-text">{{ sc.worked_example }}</p>
        </div>
        <div class="cs-script-sec" *ngIf="sc.misconceptions?.length">
          <h6>Typische Missverständnisse</h6>
          <ul>
            <li *ngFor="let m of sc.misconceptions">
              <strong>{{ m.claim }}</strong> → {{ m.correction }}
            </li>
          </ul>
        </div>
        <div class="cs-script-sec" *ngIf="sc.check_questions?.length">
          <h6>Prüffragen ({{ sc.check_questions.length }})</h6>
          <ul><li *ngFor="let q of sc.check_questions">{{ q.prompt }}</li></ul>
        </div>
        <div class="cs-script-sec" *ngIf="sc.figures?.length">
          <h6>Abbildungen</h6>
          <ul><li *ngFor="let f of sc.figures">S. {{ f.page }}{{ f.caption ? ' · ' + f.caption : '' }}</li></ul>
        </div>
      </ng-container>

      <p class="cs-empty" *ngIf="!scriptLoading && !scriptError && !scriptData?.script">
        Für diese Lehreinheit wurde noch kein Skript kompiliert.
      </p>

      <div class="cs-script-sec cs-script-note" *ngIf="!scriptLoading && scriptData?.script">
        <h6>Korrektur anfordern</h6>
        <p class="cs-muted">
          Beschreiben Sie, was fachlich fehlt oder falsch verdichtet ist. Das Skript
          wird daraufhin am Originalmaterial überarbeitet.
        </p>
        <textarea
          rows="3" [(ngModel)]="noteText" [disabled]="noteSaving"
          placeholder="z. B. Die Formel für die Prävalenz fehlt."
        ></textarea>
        <div class="cs-script-note__actions">
          <button nbButton size="tiny" status="primary"
                  [disabled]="noteSaving || (noteText || '').trim().length < 5"
                  (click)="submitNote()">
            {{ noteSaving ? 'Wird gespeichert…' : 'Überarbeitung anstoßen' }}
          </button>
          <span class="cs-muted" *ngIf="noteMessage">{{ noteMessage }}</span>
        </div>
        <ul class="cs-script-notes" *ngIf="scriptData?.notes?.length">
          <li *ngFor="let n of scriptData.notes">
            <span class="cs-badge" [class.cs-badge--assess]="n.status === 'failed'"
                  [class.cs-badge--src]="n.status !== 'failed'">
              {{ noteStatusLabel(n.status) }}
            </span>
            {{ n.note }}
          </li>
        </ul>
      </div>
    </div>
      </ng-container>
  </nb-card-body>
</nb-card>
